export default __webpack_public_path__ + "static/1123-d11d78ba5869d6324e95cda9bcfe2b92.gif";